import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
import { MenuModel } from '../menu/menu.model';
/**
 * <h4>Example of Input Model:</h4>
 * <pre>{{'{'}}
 *    type : "text",
 *    placeholder: "Input value",
 *    prefix : "",
 *    maxlength : "10",
 *    dividerColor : "",
 *    value : "",
 *    suffix : "",
 *    hint : {{'{'}}
 *      text : "max 10",
 *      align : "end"
 *    {{'}'}},
 *    icon: {{'{'}}
 *      name: "text_fields",
 *      type: "mi",
 *      size: "20px",
 *      color: {{'{'}}
 *        foreground: "black",
 *        background: "transparent"
 *      {{'}'}}
 *    {{'}'}},
 *    iconPosition:"right",
 *    menu: null
 *  {{'}'}}</pre>
 */
export class InputModel extends CoreModel {
/**
 * Type of the input. Default: text.
 */
type = 'text';
/**
 * Placeholder of the input.
 */
placeholder: string;
/**
 * Hint of the input. align value - start or end.
 */
hint: {
    text: string,
    align: string
  };
/**
 * Prefix of the input.
 */
prefix: string;
/**
 * Suffix of the input.
 */
suffix: string;
/**
 * Divider Color of the input.
 */
dividerColor: string;
/**
 * Value of the input.
 */
value: string;
/**
 * If the input is required.
 */
required: boolean;
/**
 * Input maxlength.
 */
maxlength: string;
/**
 * Icon object on the input.
 */
iconProperty: IconModel;
/**
 * Position of the icon. Can be: left or right. Default: left.
 */
iconPosition = 'left';
/**
 *  The menu object in case it is a menu button.
 */
menu: MenuModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
    if (this.iconProperty != null) { this.iconProperty = new IconModel(this.iconProperty); }
    if (this.hint == null || this.hint == null) {
      this.hint = {
        text: '',
        align: 'end'
      };
    }
  }
}

function InputModel_tsickle_Closure_declarations() {
/**
 * Type of the input. Default: text.
 * @type {?}
 */
InputModel.prototype.type;
/**
 * Placeholder of the input.
 * @type {?}
 */
InputModel.prototype.placeholder;
/**
 * Hint of the input. align value - start or end.
 * @type {?}
 */
InputModel.prototype.hint;
/**
 * Prefix of the input.
 * @type {?}
 */
InputModel.prototype.prefix;
/**
 * Suffix of the input.
 * @type {?}
 */
InputModel.prototype.suffix;
/**
 * Divider Color of the input.
 * @type {?}
 */
InputModel.prototype.dividerColor;
/**
 * Value of the input.
 * @type {?}
 */
InputModel.prototype.value;
/**
 * If the input is required.
 * @type {?}
 */
InputModel.prototype.required;
/**
 * Input maxlength.
 * @type {?}
 */
InputModel.prototype.maxlength;
/**
 * Icon object on the input.
 * @type {?}
 */
InputModel.prototype.iconProperty;
/**
 * Position of the icon. Can be: left or right. Default: left.
 * @type {?}
 */
InputModel.prototype.iconPosition;
/**
 *  The menu object in case it is a menu button.
 * @type {?}
 */
InputModel.prototype.menu;
}

